/**
 * Replace `{{token}}` placeholders from a map. Unknown tokens are left as-is.
 *
 * @param {string|null|undefined} text Source text.
 * @param {Object<string, string|number|null|undefined>} replacements Token to value map.
 * @returns {string}
 */
export function replaceTemplateTokens(text, replacements = {}) {
  return Object.entries(replacements).reduce((acc, [token, value]) => {
    const pattern = new RegExp(`\\{\\{\\s*${token}\\s*\\}\\}`, "gi");
    return acc.replace(pattern, value == null ? "" : String(value));
  }, text == null ? "" : String(text));
}
